import { render, staticRenderFns } from "./we.vue?vue&type=template&id=489f31bd&scoped=true&"
import script from "./we.vue?vue&type=script&lang=js&"
export * from "./we.vue?vue&type=script&lang=js&"
import style0 from "./we.vue?vue&type=style&index=0&id=489f31bd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489f31bd",
  null
  
)

export default component.exports